/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { COMPOSITION_BUFFER_MODE } from "@angular/forms";
import { NzSelectSearchComponent } from "ng-zorro-antd/select";

@Component({
  selector: "ui-select-search",
  templateUrl: "select-search.component.html",
  providers: [{ provide: COMPOSITION_BUFFER_MODE, useValue: false }],
})
export class UiSelectSearchComponent extends NzSelectSearchComponent {
  @Input("selectId") nzId: string | null = null;
  @Input() disabled = false;
  @Input() mirrorSync = false;
  @Input() showInput = true;
  @Input() focusTrigger = false;
  @Input() value = "";
  @Input() autofocus = false;
  @Output() readonly valueChange = new EventEmitter<string>();
  @Output() readonly isComposingChange = new EventEmitter<boolean>();
  @ViewChild("inputElement", { static: true }) inputElement!: ElementRef;
  @ViewChild("mirrorElement", { static: false }) mirrorElement?: ElementRef;
}
